var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import MenuIcon from "@mui/icons-material/Menu";
import NotificationsIcon from "@mui/icons-material/Notifications";
import SearchIcon from "@mui/icons-material/Search";
import { Avatar, Box, Button, IconButton, Stack } from "@mui/material";
import AppBar from "@mui/material/AppBar";
import Container from "@mui/material/Container";
import Toolbar from "@mui/material/Toolbar";
import React, { useContext, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useLogout } from "../ApiProvider";
import { UserContext } from "../auth/UserProvider";
import { MobileDrawer } from "../mobile/nav/MobileDrawer";
import { NotificationsBadge } from "../notifications/NotificationsBadge";
import { Logo } from "./Logo";
import { SearchBar } from "./SearchBar";
import { UserMenu } from "./UserMenu";
function NavBar() {
    var _a, _b;
    var _c = useContext(UserContext), user = _c.user, setUser = _c.setUser, setLoading = _c.setLoading;
    var _d = __read(useState(null), 2), anchorElUser = _d[0], setAnchorElUser = _d[1];
    var _e = __read(useState(false), 2), mobileDrawerOpen = _e[0], setMobileDrawerOpen = _e[1];
    var navigate = useNavigate();
    var mutation = useLogout(function () {
        setLoading(true);
    }, function () {
        setUser(null);
        navigate("/login");
        setLoading(false);
    }, function () { });
    var handleUserMenuOpen = function (event) {
        setAnchorElUser(event.currentTarget);
    };
    var handleUserMenuClose = function () {
        setAnchorElUser(null);
    };
    return (_jsxs(Box, { sx: { flexGrow: 1 }, children: [_jsx(AppBar, { position: "static", children: _jsx(Container, { maxWidth: "lg", children: _jsxs(Toolbar, { disableGutters: true, sx: { width: "100%" }, children: [_jsxs(Box, { sx: { display: "flex", alignItems: "center", flexGrow: 1 }, children: [_jsx(IconButton, { sx: { display: { xs: "flex", md: "none" }, mr: 1 }, onClick: function () { return setMobileDrawerOpen(true); }, color: "inherit", "aria-label": "open drawer", children: _jsx(MenuIcon, {}) }), _jsx(Logo, {}), user && (_jsxs(_Fragment, { children: [_jsx(Button, { to: "/", component: Link, sx: {
                                                    ml: 2,
                                                    color: "white",
                                                    display: { xs: "none", md: "block" },
                                                }, children: "Home" }, "home-key"), _jsx(Button, { to: "/teams", component: Link, sx: {
                                                    ml: 2,
                                                    color: "white",
                                                    display: { xs: "none", md: "block" },
                                                }, children: "Teams" }, "teams-key"), _jsx(Button, { to: "/leagues", component: Link, sx: {
                                                    ml: 2,
                                                    color: "white",
                                                    display: { xs: "none", md: "block" },
                                                }, children: "Leagues" }, "leagues-key"), _jsx(Button, { to: "/venues", component: Link, sx: {
                                                    ml: 2,
                                                    color: "white",
                                                    display: { xs: "none", md: "block" },
                                                }, children: "Venues" }, "venues-key")] }))] }), user ? (_jsxs(React.Fragment, { children: [_jsx(Box, { sx: {
                                            display: { xs: "none", md: "flex" },
                                            alignItems: "center",
                                        }, children: _jsxs(Stack, { direction: "row", spacing: 4, alignItems: "center", children: [_jsx(SearchBar, {}), _jsx(IconButton, { component: Link, to: "/invitations", color: "inherit", "aria-label": "invitations", children: _jsx(MailOutlineIcon, {}) }), _jsx(NotificationsBadge, {}), _jsx(IconButton, { onClick: handleUserMenuOpen, sx: { p: 0 }, children: _jsx(Avatar, { alt: user.firstName, src: (_a = user.picture) !== null && _a !== void 0 ? _a : undefined, imgProps: { referrerPolicy: "no-referrer" } }) })] }) }), _jsx(Box, { sx: {
                                            display: { xs: "flex", md: "none" },
                                            alignItems: "center",
                                        }, children: _jsxs(Stack, { direction: "row", spacing: 1, alignItems: "center", children: [_jsx(IconButton, { sx: { p: 0.5 }, onClick: function () { return navigate("/search"); }, color: "inherit", "aria-label": "navigate to search", children: _jsx(SearchIcon, {}) }), _jsx(IconButton, { sx: { p: 0.5 }, onClick: function () { return navigate("/invitations"); }, color: "inherit", "aria-label": "navigate to invitations", children: _jsx(MailOutlineIcon, {}) }), _jsx(IconButton, { sx: { p: 0.5 }, onClick: function () { return navigate("/notifications"); }, color: "inherit", "aria-label": "navigate to notifications", children: _jsx(NotificationsIcon, {}) }), _jsx(Avatar, { alt: user.firstName, src: (_b = user.picture) !== null && _b !== void 0 ? _b : undefined, sx: { width: 24, height: 24 }, imgProps: { referrerPolicy: "no-referrer" } })] }) })] })) : (_jsx(Button, { color: "inherit", component: Link, to: "/login", sx: { display: "inline-flex" }, children: "Login" }))] }) }) }), _jsx(UserMenu, { anchorElUser: anchorElUser, onUserMenuClose: handleUserMenuClose, onLogoutClick: function () {
                    handleUserMenuClose();
                    mutation.mutate();
                } }), _jsx(MobileDrawer, { mobileDrawerOpen: mobileDrawerOpen, setMobileDrawerOpen: setMobileDrawerOpen, user: user, logoutMutation: mutation })] }));
}
export default NavBar;
